<template>
  <div class="content">
    <h1 class="content__title">Lista de Atributos</h1>
    <span class="content__details">Listado de atributos de los productos como colores, tamaños, formas, tipos, colores y otros</span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Lista de Atributos</h2>
          <div class="main__results">
            <div class="result" v-if="attributes === 'loading'">
              <div class="result__data">
                <img class="result__loading" src="/static/img/waiting.gif" alt="Cargando información">
              </div>
            </div>
            <div class="result" v-else-if="!attributes">
              <div class="result__data">
                <h2 class="result__title">No se encontraron resultados</h2>
              </div>
            </div>
            <div class="result" v-else v-for="(attribute, index) in attributes" :key="index">
              <div class="result__data">
                <h2 class="result__title" v-text="'Nombre: ' + attribute.name_es"></h2>
                <p class="result__detail" v-text="'Tipo: ' + attribute.type_name_es"></p>
              </div>
              <div class="result__options">
                <router-link class="btn btn__default btn--small" :to="{name: 'attributeEdit', params: {id: attribute.id}}" > Editar</router-link>
                <button class="btn btn__caution btn--small" @click="deleteAttribute(attribute.id)">Borrar</button>
              </div>
            </div>

          </div>
          <pagination v-if="pagination.pages !== null" :config="pagination"></pagination>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">NAVEGACIÓN</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'productList', params: {page: 1}}">Ir a Productos</router-link>
        <router-link class="btn btn--small btn__default" :to="{name: 'attributeNew'}">Nuevo atributo</router-link>
        <br>
        <h2 class="sidebar__title">CARACTERÍSTICAS</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'attributeTypeList', params: {page: 1}}">Tipos de Atributo</router-link>
        <br>
        <h2 class="sidebar__title">FILTROS</h2>
        <div class="form__select-container">
          <select name="types" id="types" class="form__select" @change="filterByType">
            <option :value="null">Todos los tipos</option>
            <option v-for="(type, index) in types" :key="index" :value="type.id" v-text="type.name_es"></option>
          </select>
        </div>
      </aside>
    </div>
  </div>
</template>

<script>
import httpService from '@/api/request'
import pagination from '@/components/layout/pagination'
import confirmation from '@/components/layout/confirmation'
export default {
  mixins: [httpService],
  components: {
    pagination,
    confirmation
  },
  data: function () {
    return {
      attributes: 'loading',
      types: [],
      confirm: false,
      pagination: {
        maxButtons: 8,
        results: null,
        pages: null
      },
      maxResults: 12,
      page: 1,
      id: null
    }
  },
  created: function () {
    this.page = this.$route.params.page
    this.getAttributes()
    this.getTypes()
  },
  mounted: function () {
    this.$on('continue', () => {
      this.confirm = false
      this.proccedToDelete()
    })
  },
  watch: {
    '$route.path': function () {
      this.page = this.$route.params.page
      this.getAttributes()
      this.getTypes()
    }
  },
  methods: {
    deleteAttribute: function (id) {
      this.confirm = true
      this.id = id
    },
    proccedToDelete: function () {
      let httpRequest = {
        module: 'attributes'
      }
      this.delete(this.id, httpRequest)
        .then(
          () => {
            this.getAttributes()
            this.$store.commit('notificate', {
              title: 'ATTRIBUTO BORRADO',
              text: 'El atributo ha sido borrado correctamente.',
              type: 'success'
            })
          }
        )
    },
    getAttributes: function (filters = '') {
      let httpRequest = {
        module: 'attributes',
        params: '?fields=name_es,id,type_name_es&limit=' + this.maxResults + '&page=' + this.page + '&embed=pagination' + filters
      }
      this.get(httpRequest)
        .then(
          attributes => {
            this.attributes = attributes.data
            this.pagination.pages = attributes.pagination.pages
            this.pagination.currentPage = attributes.pagination.current_page
            this.pagination.results = attributes.pagination.results
          }
        )
        .catch(
          () => {
            this.attributes = null
            this.pagination.pages = null
            this.pagination.currentPage = null
            this.pagination.results = null
            if (this.page > 1) {
              this.$router.push({name: 'attributeList', params: {page: this.page - 1}})
            }
          }
        )
    },
    getTypes: function () {
      let httpRequest = {
        module: 'attribute_types',
        params: '?fields=name_es,id'
      }
      this.get(httpRequest)
        .then(
          types => {
            this.types = types.data
          }
        )
        .catch(
          () => {
            this.types = []
          }
        )
    },
    filterByType: function (e) {
      let id = e.target.value
      let filters = ''
      if (id && id > 0) {
        filters = '&type_id=eq:' + id
      }
      this.getAttributes(filters)
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../../assets/sass/objects/_btns"
@import "../../../assets/sass/components/layout/_forms"
</style>



// WEBPACK FOOTER //
// src/components/products/attributes/list.vue